'use strict';
// import $ from 'jquery';

import iziModal from 'iziModal';
import { debounce, isPhablet, easeOutExpo  } from '../../../_js/_helper';


export default class HeroBanner {
  constructor() {
    let $heroBanner = $('.js-hero-banner-heading');
    let isMobileDevice = isPhablet();

    let $heroBannerItem = $('.parallax, .js-image-banner-link-wrapper .parallax-image');

    let heroBannerHeight = function(){
      if($heroBannerItem){
        $('.parallax, .js-image-banner-link-wrapper .parallax-image').each(function(i,ele){
          let header ;


            let navHeight = 98;
            if($(window).width() < 767){
              navHeight = 44;
            }else if($(window).width() < 980){
              navHeight = 93;
            }

          let windowHeight = window.innerHeight - navHeight;
          if($(ele).hasClass('parallax-image') && isMobileDevice){
            windowHeight= windowHeight + 100 ;
          }

          $(ele).css('height', windowHeight);
        })
      }
    }
    heroBannerHeight();

    let cachedWindowWidth = $(window).width();

    $(window).on('resize', debounce(function () {
      let newWidth = $(window).width();
      if(cachedWindowWidth !== newWidth && isMobileDevice){
        heroBannerHeight();
      } else if(!isMobileDevice){
          heroBannerHeight();
      }
      cachedWindowWidth = $(window).width();
    }, 250));



    let $imageWidget = $('.image-widget');

    let imageWidgetHeight = function(){
      if($heroBannerItem){

        $imageWidget.each(function(i,ele){
          let header ;
          let windowHeight = window.innerHeight*0.8;
          if(isMobileDevice){
            windowHeight = window.innerHeight*0.7;
          }
          $(ele).css('max-height', windowHeight);
        })
      }
    }
    imageWidgetHeight();

    $(window).on('resize', debounce(function () {
      let newWidth = $(window).width();
      if(cachedWindowWidth !== newWidth && isMobileDevice){
        imageWidgetHeight();
      } else if(!isMobileDevice){
          imageWidgetHeight();
      }
      cachedWindowWidth = $(window).width();
    }, 250));





      if ($heroBanner.length){
        var $heroHeading = $('.js-hero-banner-heading'),
            $heroSubheading = $('.js-hero-banner-subtext'),
            $horizontalLine = $('.js-horizontal-line'),
            $button = $('.hero-banner-inner .cta'),
            $chevron = $('.parallax-text-overlay .chevron-container'),
            $heroTextOverlay = $('.hero-text-overlay'),
            $heroBannerImage = $('.js-hero-banner');



        if($heroHeading.length){
          var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter"}});

          var tween = new TimelineMax()
            .from($heroBannerImage, 3, {scale:"1.5"})
            .to($heroTextOverlay, 0.5, {opacity:1})
            .from($heroHeading, 0.8, {y: "-=50", opacity:0}, '-=0.3')
            .from($heroSubheading, 0.8, {y: "-=50", opacity:0}, '-=0.4')
            .from($horizontalLine, 0.7, { scaleX:"0"}, '-=0.3')
            .to($button, 0.7, { opacity:1}, '-=0.7' )
            .to($chevron, 0.7, { opacity:1}, '-=0.5' );

          //scenes
          new ScrollMagic.Scene({triggerElement: '.js-hero-banner-heading' , triggerHook: 0})
                  .setTween(tween)
                  .addTo(controller)
                  .reverse(false);
      }




      }

      const $tilesContent= $('.tiles-content-cards-container');
      const $tilesContentCard = $('.tiles-content-card');
  if($tilesContent.length){
    $.each($tilesContent,function(i, el){

      var card = $(this).find('.tiles-content-card');
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter"}});

    var animateSlideUp = new TimelineMax()
      .staggerFrom(card, 0.7, {y:80, opacity:0, ease:Power1.easeInOut}, 0.3)
    // build scenes
     let windowheight = (window.innerHeight)/2;
    var scene = new ScrollMagic.Scene({triggerElement: this})
            .setTween(animateSlideUp)
            .addTo(controller)

    })
  }


  //IMAGE BANNER
      const $parallaxImage1 = $('.js-parallax-image');
  if($parallaxImage1.length){
    $.each($parallaxImage1,function(i, el){
      var $parallaxImageInner = $(this).find('.parallax-image-inner');
      // init controller
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1 , duration: "200%"}});

    var animateParallax = new TimelineMax()
      .to($parallaxImageInner,1, {y:"+=300"})
    // build scenes
     let windowheight = (window.innerHeight)/2;
    new ScrollMagic.Scene({triggerElement: this, triggerHook: 1,  duration: "200%"})
            .setTween(animateParallax)
            .addTo(controller)

    })
  }

  //TEXT BLOCK
  const $textBlockBody = $('.text-block-body');
  if($textBlockBody .length){
    $.each($textBlockBody ,function(i, el){
      let $this = $(this);
      // init controller
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1 }});
    var fadeIn = new TimelineMax()
      .from($this,0.5, {y:"+60", opacity: 0,delay:0.3})
    // build scenes
    new ScrollMagic.Scene({triggerElement: this, triggerHook: 1})
            .setTween(fadeIn)
            .addTo(controller)
            .reverse(false);
    })
  }


  //ABOUT US CARDS
  const $aboutUs = $('.about-us-content');
  if($aboutUs.length){
    $.each($aboutUs,function(i, el){
      let $this = $(this),
          $title = $(this).find('.about-us-heading'),
          $rte = $(this).find('.about-us-body-rte'),
          $logo = $(this).find('.about-us-logo'),
          $button = $(this).find('.link-wrapper');

      // init controller
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1 }});
    var fadeIn = new TimelineMax()
      .from($this,0.5, {y:"+50", opacity: 0})
      .from($title,0.4, {y:"50", opacity: 0}, "-=0.3")
      .from($rte,0.4, {y:"50", opacity: 0}, "-=0.3")
      .from($logo,0.4, {y:"50", opacity: 0}, "-=0.3")
      .from($button,0.4, {y:"50", opacity: 0}, "-=0.3")

    // build scenes
    new ScrollMagic.Scene({triggerElement: this, triggerHook: 1})
            .setTween(fadeIn)
            .addTo(controller)
            .reverse(false);
    })
  }


  //CONTACT INFO
  const $contactUsInfo = $('.contact-information');
  if($contactUsInfo.length){
    $.each($contactUsInfo,function(i, el){
      let $this = $(this)

      // init controller
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1 }});
    var fadeIn = new TimelineMax()
      .from($this,0.4, {y:"+80", opacity: 0,delay:0.3})

    // build scenes
    new ScrollMagic.Scene({triggerElement: this, triggerHook: 1})
            .setTween(fadeIn)
            .addTo(controller)
            .reverse(false);
    })
  }

  //CONTACT US FORM
  const $contactUsForm = $('.contact-us-form');
  if($contactUsForm.length){
    $.each($contactUsForm,function(i, el){
      let $this = $(this)

      // init controller
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1 }});
    var fadeIn = new TimelineMax()
      .from($this,0.4, {y:"+80", opacity: 0,delay:0.3})

    // build scenes
    new ScrollMagic.Scene({triggerElement: this, triggerHook: 1})
            .setTween(fadeIn)
            .addTo(controller)
            .reverse(false);
    })
  }



  //HERO BANNER
  if($('.js-parallax').length){

        // init controller
      var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

      var animateParallax = new TimelineMax()
        .to(".js-parallax > .js-banner", 1, {y:400,ease: Linear.easeNone})
      // build scenes
       let windowheight = (window.innerHeight)/2;
      var scene = new ScrollMagic.Scene({triggerElement: ".parallax", triggerHook: 0, offset: windowheight, duration: "200%"})
              .setTween(animateParallax)
              .addTo(controller)


  }


  //CTA BANNER

  if($('.js-cta-parallax').length){

        // init controller
      var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

      var animateParallax = new TimelineMax()
        .to(".js-cta-parallax > .js-cta-banner", 1, {y:"+=300"})
      // build scenes
       let windowheight = (window.innerHeight)/2;
      var scene = new ScrollMagic.Scene({triggerElement: ".js-cta-parallax", triggerHook: 1, duration: "200%"})
              .setTween(animateParallax)
              .addTo(controller)


  }



  //detail page

  let $detailHeader = $('.detail-header');
  let $detailHeaderTitle = $('.detail-header-title');
  let $socialMedia = $('.social-media-sharing-inner a');

  if($detailHeader.length){
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter"}});

    var tween = new TimelineMax()
      // .from($detailHeaderTitle, 1, {x: "-=20%"})
      .staggerFrom($socialMedia, 0.7, {y:80, delay: 0.2, opacity:0, ease:Power1.easeInOut}, 0.3)


    //scenes
    new ScrollMagic.Scene({triggerElement: '.detail-header-title' , triggerHook: 0})
            .setTween(tween)
            .addTo(controller)
            .reverse(false);
  }



  //news listing page

  let $listingCard = $('.js-listing-card');
  if($listingCard.length){
    var controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 1}});
    var tween;
    // $.each($listingCard,function(i, el){
      if(true){
        tween = new TimelineMax()
          .staggerFrom($listingCard, 0.5, {y:30, opacity:0, delay: 0.3, ease:Power1.easeInOut}, 0.1)
      }else{
        tween = new TimelineMax()
          .from($(this), 0.5, {y:30, opacity:0, ease:Power1.easeInOut})
      }
      //scenes
      new ScrollMagic.Scene({triggerElement: $listingCard})
              .setTween(tween)
              .addTo(controller)

    // })


  }


      //view more
      $('.chevron-container').on('click', function(e){
          e.preventDefault();
          if(!isMobileDevice){
            let navHeight = 98;
            if($(window).width() < 980){
              navHeight = 93;
            }
            TweenMax.to(window, 1, {scrollTo:{y:"#main-content", autoKill:false, offsetY:navHeight}, ease:Power2.easeInOut});
          }else {
            TweenMax.to(window, 1, {scrollTo:{y:"#main-content", autoKill:false, offsetY:45}, ease:Power2.easeInOut});
          }


      })


        var target = window.location.hash;
          target.replace('#', '');

          // also remove '/' to avoid issues with the jQuery selector
          target = target.replace('/', '');
          if(target && $(target).length)
          {
            window.location.hash = "";
          }

          if (window.location.hash) {
            setTimeout(function() {
              window.scrollTo(0, 0);
            }, 1);
          }


          $(window).on("load", function(e){
            e.preventDefault();

            let hashLocation = window.location.hash;
            hashLocation = target;


            // If we have a hash location do stuff
            if ($(target).length && !isMobileDevice) {
              function getDuration(distance, pixelsPerSecond){
              	var duration = distance / pixelsPerSecond;
              	return duration;
              }
              let navHeight = 98;

              if($(window).width() < 980){
                navHeight = 93;
              }
              if($(hashLocation).hasClass('js-image-banner-link-wrapper')){
                navHeight = $(hashLocation).offset().top + ($(hashLocation).height() - $(window).height());
                TweenMax.to(window, 1.8, {scrollTo:{y:navHeight, autoKill:true}, ease:Quad.easeInOut});
                history.pushState(null,null,target);

              }else if($(hashLocation).hasClass('page-find-us-heading')){
                navHeight = navHeight + 60;
                TweenMax.to(window, 1.8, {scrollTo:{y:hashLocation, autoKill:true, offsetY: navHeight}, ease:Quad.easeInOut});
                history.pushState(null,null,target);
              } else {
                TweenMax.to(window, 1.8, {scrollTo:{y:hashLocation, autoKill:true, offsetY: navHeight}, ease:Quad.easeInOut});
                history.pushState(null,null,target);
              }

            } else if($(hashLocation).length){
              if($(hashLocation).hasClass('js-image-banner-link-wrapper')){
                var navHeight = $(hashLocation).offset().top + ($(hashLocation).height() - $(window).height());
                TweenMax.to(window, 1.8, {scrollTo:{y:navHeight, autoKill:false}, ease:Quad.easeInOut});
                history.pushState(null,null,target);
              }else if($(hashLocation).hasClass('page-find-us-heading')){
                  TweenMax.to(window, 1.8, {scrollTo:{y:hashLocation, autoKill:false, offsetY:105}, ease:Quad.easeInOut});
                  history.pushState(null,null,target);
              }else{
                TweenMax.to(window, 1.8, {scrollTo:{y:hashLocation, autoKill:false, offsetY:45}, ease:Quad.easeInOut});
                history.pushState(null,null,target);
              }
            }
          })



      //when clicking on URLS with anchor tags and we are on the same page
        $('.lvl1 a, a').on('click touchend', function(e){
          if($(this).attr('href') === undefined || $(this).attr('href') === ''){
            return false;
          }

          var hashLocationSamePage = false;
          if(this.hash && $(this.hash).length){
            if($('.menu.js-mobile-menu').is(':visible')){
              $('.menu.js-mobile-menu').trigger('click');
            }

            e.preventDefault();



            if (this.hash) {
                hashLocationSamePage  = this.hash;
                setTimeout(function() {
                    hashLocationSamePage  = this.hash;
                }, 1);
            }

            if ($(hashLocationSamePage).length && !isMobileDevice) {

                  let navHeight = 98;
                  if($(window).width() < 980){
                    navHeight = 93;
                  }

                  if($(hashLocationSamePage).hasClass('js-image-banner-link-wrapper')){
                    navHeight = $(hashLocationSamePage).offset().top + ($(hashLocationSamePage).height() - $(window).height());
                    TweenMax.to(window, 1.5, {scrollTo:{y:navHeight, autoKill:false}, ease:Power2.easeInOut});
                  }else{

                  TweenMax.to(window, 1.5, {scrollTo:{y:hashLocationSamePage , autoKill:false, offsetY: navHeight }, ease:Power2.easeInOut});
                  }

            } else if($(hashLocationSamePage).length){
                  if($(hashLocationSamePage).hasClass('js-image-banner-link-wrapper')){
                    var navHeight = $(hashLocationSamePage).offset().top + ($(hashLocationSamePage).height() - $(window).height());
                    TweenMax.to(window, 1.5, {scrollTo:{y:navHeight, autoKill:false}, ease:Power2.easeInOut});

                  }else{
                    TweenMax.to(window, 1.5, {scrollTo:{y:hashLocationSamePage , autoKill:false, offsetY:45}, ease:Power2.easeInOut});
                  }
            }
          }

        })



        if($('.modal-video-wrapper').length || $('.video-youtube.-hero').length){
          var tag = document.createElement('script');
          tag.id = 'iframe-demo';
          tag.src = 'https://www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          var player;
          var playerBackground;



          window.onYouTubeIframeAPIReady = function(){

            if( $('#video-background').length ){
              playerBackground = new YT.Player('video-background', {
                events: {
                  'onReady': onPlayerReadyBackground,
                  'onStateChange': onPlayerStateChangeBackground
                }
              });
            }
            if($('#modal-video').length || $('#detail-page-launch-video').length){
              player = new YT.Player('modal-video', {
                  events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                  }
              });
            }

          }
          function onPlayerReady(event){

            let $player = event.target;
            // bind events

            var detailPageLaunch = document.getElementById("detail-page-launch-video");
            if(detailPageLaunch){
              detailPageLaunch.addEventListener("click", function() {
                $('#play-button').show();
                player.playVideo();
              });
            }

            var launchVideoButton = document.getElementsByClassName("video-popup")[0];
            if(launchVideoButton){
              launchVideoButton.addEventListener("click", function() {
                $('#play-button').show();
                player.playVideo();
              });
            }

            var playButton = document.getElementById("play-button");
            if(playButton){
                playButton.addEventListener("click", function() {
                player.playVideo();
              });
            }




          }
          function onPlayerStateChange(event){


              if(player.getPlayerState() === 0){
                $('.modal-video-wrapper iframe').css('opacity','0');
                $('#play-button').show();
              }
              if(player.getPlayerState() === 5){
              }
              if(player.getPlayerState() === 1){
                $('.modal-video-wrapper iframe').css('opacity','1');
                $('#play-button').hide();

              }
          }

          function onPlayerReadyBackground(event){
            event.target.playVideo();

          }
          function onPlayerStateChangeBackground(event){
            if(event.target.getPlayerState() === 0){
              event.target.playVideo();
            }
          }


          setTimeout(function(){
            if($('#video-background').length){
              if(playerBackground.getPlayerState() === 5){
                $('.hero-banner-youtube-poster').css('opacity','1');
              } else{
                $('.hero-banner-youtube-poster').css('opacity','0');
                $('.video-youtube.-hero').show();
              }
            }

          }, 1000)


        }
      //link to fly through

  $(document).ready(function(){
    var $modalVideo = $('#modal-video');

    $('a.video-popup[data-modal-button-id]').on('click', function(event) {
      event.preventDefault();
        var $modalVideo = $('#modal-video');


      var url =  $modalVideo.data('src');
      var modalID = $(this).attr('data-modal-button-id');
      var modal2 = $('.video-js-modal-container');

      setTimeout(function(){
        modal2.focus();
      }
      ,100);


      modal2.iziModal({
          headerColor: '#26A69A',
          width: '50%',
          overlayColor: 'rgba(0, 0, 0, 1)',
          fullscreen: true,
          width: '80%',
          transitionIn: 'fadeInUp',
          transitionOut: 'fadeOutDown',



      });
        modal2.iziModal('open');
      });




    if($('.js-video-banner-container-hero').length || $('.video-js-modal-container').length){


      function findAncestor (el, cls) {
          while ((el = el.parentElement) && !el.classList.contains(cls));
          return el;
      }

      var videos = document.getElementsByClassName("btn-video-js-modal");
          for(var i = 0; i < videos.length; i++)
          {
          var videoPlayerModal;

          var parent = findAncestor(videos[i], 'video-banner-container');

          var modalVideo = parent.getElementsByClassName('btn-video-js-modal')[0];
          var modalWindow = parent.getElementsByClassName('video-js-modal-container')[0];



          }

          $('.video-js-modal-container').each(function(i,ele){
            $(ele).iziModal({
              headerColor: '#26A69A',
              width: '50%',
              overlayColor: 'rgba(0, 0, 0, 1)',
              fullscreen: true,
              width: '80%',
              transitionIn: 'fadeInUp',
              transitionOut: 'fadeOutDown',
              onClosed: function(){
                $('#play-button').show();
                player.pauseVideo();
              }
            });
          })
    }

  })




  }
}
